// extracted by mini-css-extract-plugin
module.exports = {"Layout":"LayoutHeaderMobile-module--Layout--15o0m"};